document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.brain-lp-btn').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            if (btn.classList.contains('brain-lp-btn-try-dynamic')) return;

            e.preventDefault();

            let target;

            if (btn.classList.contains('brain-lp-btn-four')) {
                target = document.querySelector('#try-dynamic-product-box');
            } else {
                target = document.querySelector('.brain-lp-four');
            }

            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }
        });
    });
});